import { gql } from 'apollo-angular';

export const PROJECT_INSTALLMENT_FUNDING_CONDITION_FRAGMENT = gql`
    fragment ProjectInstallmentFundingConditionFields on ProjectInstallmentFundingCondition {
      id
      condition_number
      name
      nickname
      include_in_package
      notes
      additional_notes
      condition_status_date
      projectInstallmentFunding {
        id
        funding_number
        projectInstallment {
          installment_number
        }
      }

      projectInstallmentFundingConditionStatus {
        id
        name
      }
      projectInstallmentFundingConditionFiles {
        id
        filename
        fileurl
        include_in_package
        projectInstallmentFundingCondition{
          id
        }
      }
      projectInstallmentFundingConditionApprovalLogs {
        id
        user {
          person {
            name
          }
        }
        approval_status_date
        projectInstallmentFundingConditionApprovalStatus {
          id
          name
        }
        projectInstallmentFundingConditionApprovalType {
          id
          name
        }
      }
      projectInstallmentFundingConditionApprovals {
        id
        user {
          person {
            name
          }
        }
        approval_status_date
        projectInstallmentFundingConditionApprovalStatus {
          id
          name
        }
        projectInstallmentFundingConditionApprovalType {
          id
          name
        }
      }
    }
`

export const PROJECT_INSTALLMENT_FUNDING_FRAGMENT = gql`
  fragment ProjectInstallmentFundingFields on ProjectInstallmentFunding {
    id
    funding_number
    funding_amount
    funding_status_date
    total_adjuster_amount
    total_remaining_amount
    projectInstallment {
      id
      installment_number
    }
    projectInstallmentFundingPayments {
      id
      fund {
        id
        name
      }
      certificatedOutlet {
        id
        organization {
            id
            name
        }
      }
      amount
      adjuster
      active
      warehouse
    }
    projectInstallmentFundingPackages {
      id
      fund {
        id
        name
      }
      certificatedOutlet {
        id
        organization {
            id
            name
        }
      }
      warehouse
      fileurl
      active
      modified
      status
    }
    projectInstallmentFundingStatus {
      id
      name
    }
    projectInstallmentFundingConditions {
      ...ProjectInstallmentFundingConditionFields
    }
  }
  ${PROJECT_INSTALLMENT_FUNDING_CONDITION_FRAGMENT}
`

export var get_equity_installments = gql`
  query getProjectInstallments($project_id: ID!){
    project_installments_by_project(project_id: $project_id){
      id
      project {
        id
        name
        sharepoint_folder
      }
      installment_number
      installment_amount
      total_funded_amount
      total_adjuster_amount
      total_remaining_amount
      notes
      status_date
      certificated
      projectInstallmentStatus{
        id
        name
      }
      original_commitment_date
      original_installment_amount
      projectInstallmentFundings {
        id
        funding_number
        funding_amount
        funding_status_date
        total_adjuster_amount
        total_remaining_amount
        projectInstallmentFundingPayments {
          id
          fund {
            id
            name
          }
          certificatedOutlet {
            id
            organization {
              id
              name
            }
          }
          amount
          adjuster
          active
          warehouse
        }
        projectInstallmentFundingPackages {
          id
          fund {
            id
            name
          }
          certificatedOutlet {
            id
            organization {
                id
                name
            }
          }
          warehouse
          fileurl
          active
          status
          modified
        }
        projectInstallmentFundingStatus {
          id
          name
        }
        projectInstallmentFundingConditions {
          id
          condition_number
          name
          nickname
          notes
          additional_notes
          include_in_package
          condition_status_date
          projectInstallmentFunding {
            funding_number
            id
            projectInstallment {
              installment_number
            }
          }

          projectInstallmentFundingConditionStatus {
            id
            name
          }
          projectInstallmentFundingConditionFiles {
            id
            filename
            fileurl
            include_in_package
            projectInstallmentFundingCondition{
              id
            }
          }
          projectInstallmentFundingConditionApprovalLogs {
            id
            user {
              person {
                name
              }
            }
            approval_status_date
            projectInstallmentFundingConditionApprovalStatus {
              id
              name
            }
            projectInstallmentFundingConditionApprovalType {
              id
              name
            }
          }
          projectInstallmentFundingConditionApprovals {
            id
            user {
              person {
                name
              }
            }
            approval_status_date
            projectInstallmentFundingConditionApprovalStatus {
              id
              name
            }
            projectInstallmentFundingConditionApprovalType {
              id
              name
            }
          }
        }
      }
    }
    project(id: $project_id){
      name
      id
      sharepoint_folder
    }
    project_installment_statuses {
      id
      name
      sort
    }
    project_installment_funding_statuses {
      id
      name
      sort
    }
    project_installment_funding_condition_statuses {
      id
      name
      sort
    }
    project_installment_funding_condition_approval_statuses {
      id
      name
      sort
    }
    project_installment_funding_condition_approval_types {
      id
      name
    }
    me {
      id
      installmentPermissions: permissionsForResource(resourceType: PROJECTINSTALLMENT){
        _create
        _read
        _edit
        _delete
        authorized_fields
      }
      fundingPermissions: permissionsForResource(resourceType: PROJECTINSTALLMENTFUNDING){
        _create
        _read
        _edit
        _delete
        authorized_fields
      }
      conditionPermissions: permissionsForResource(resourceType: PROJECTINSTALLMENTFUNDINGCONDITION){
        _create
        _read
        _edit
        _delete
        authorized_fields
      }
      approvalPermissions: permissionsForResource(resourceType: PROJECTINSTALLMENTFUNDINGCONDITIONAPPROVAL){
        _create
        _read
        _edit
        _delete
        authorized_fields
      }
      packagePermissions: permissionsForResource(resourceType: PROJECTINSTALLMENTFUNDINGPACKAGE){
        _create
        _edit
        _read
        _delete
        authorized_fields
      }
      paymentPermissions: permissionsForResource(resourceType: PROJECTINSTALLMENTFUNDINGPAYMENT){
        _create
        _read
        _edit
        _delete
        authorized_fields
      }
      filePermissions: permissionsForResource(resourceType: PROJECTINSTALLMENTFUNDINGCONDITIONFILE){
        _create
        _read
        _edit
        _delete
        authorized_fields
      }
      fundingStatusPermissions: permissionsForResource(resourceType: PROJECTINSTALLMENTFUNDINGSTATUS, resourceId: "4DC278CD-00BF-4D59-ABF7-485EB213A9EE"){
        _edit
        _read
        authorized_fields
      }
    }
  }
`

export var get_package_files = gql`
    query getFundingPackages($project_installment_funding_id: ID!){
      getFundingPackages(project_installment_funding_id: $project_installment_funding_id){
        id
        fund {
          id
          name
        }
        certificatedOutlet {
          id
          organization {
            id
            name
          }
        }
        warehouse
        fileurl
        active
        status
        modified
      }
    }
`

export var get_installment_funding_payments = gql`
    query projectInstallmentFundingPayments($project_installment_funding_id: ID!){
      project_installment_funding_payments(project_installment_funding_id: $project_installment_funding_id){
        id
        fund {
          id
          name
        }
        certificatedOutlet {
          id
          organization {
            id
            name
          }
        }
        projectInstallmentFunding {
          id
        }
        amount
        adjuster
        active
        warehouse
      }
    }
`

export var get_sso_token = gql`
    query me {
      me {
        ssoTokens {
          access_token
          refresh_token
          created
          active
          last_verified
        }
      }
    }
`

export var refresh_sso_token = gql`
  mutation refreshToken($refresh_token: String!){
    refreshToken(refresh_token: $refresh_token)
  }
`

export var get_log_history = gql`
    query getConditionApprovalLogs($project_installment_funding_condition_id: ID!){
      project_installment_funding_condition_approval_logs(project_installment_funding_condition_id: $project_installment_funding_condition_id){
        id
        user {
          person {
            name
          }
        }
        approval_status_date
        projectInstallmentFundingConditionApprovalStatus {
          id
          name
        }
        projectInstallmentFundingConditionApprovalType {
          id
          name
        }
      }
    }
`

export var get_installment_by_id = gql`
    query getInstallment($id: ID!){
      project_installment(id: $id){
        id
        project {
          id
          name
        }
        installment_number
        installment_amount
        total_funded_amount
        total_adjuster_amount
        total_remaining_amount
        notes
        status_date
        certificated
        projectInstallmentStatus{
          id
          name
        }
        original_commitment_date
        original_installment_amount
        projectInstallmentFundings {
          id
          funding_number
          funding_amount
          funding_status_date
          total_adjuster_amount
          total_remaining_amount
          projectInstallmentFundingPayments {
            id
            fund {
              id
              name
            }
            certificatedOutlet {
              id
              organization {
                id
                name
              }
            }
            amount
            adjuster
            active
            warehouse
          }
          projectInstallmentFundingPackages {
            id
            fund {
              id
              name
            }
            certificatedOutlet {
              id
              organization {
                id
                name
              }
            }
            warehouse
            fileurl
            active
            status
            modified
          }
          projectInstallmentFundingStatus {
            id
            name
          }
          projectInstallmentFundingConditions {
            id
            condition_number
            name
            nickname
            notes
            additional_notes
            condition_status_date
            include_in_package
            projectInstallmentFunding {
              funding_number
              projectInstallment {
                installment_number
              }
            }

            projectInstallmentFundingConditionStatus {
              id
              name
            }
            projectInstallmentFundingConditionFiles {
              id
              filename
              fileurl
              include_in_package
              projectInstallmentFundingCondition{
                id
              }
            }
            projectInstallmentFundingConditionApprovalLogs {
              id
              user {
                person {
                  name
                }
              }
              approval_status_date
              projectInstallmentFundingConditionApprovalStatus {
                id
                name
              }
              projectInstallmentFundingConditionApprovalType {
                id
                name
              }
            }
            projectInstallmentFundingConditionApprovals {
              id
              user {
                person {
                  name
                }
              }
              approval_status_date
              projectInstallmentFundingConditionApprovalStatus {
                id
                name
              }
              projectInstallmentFundingConditionApprovalType {
                id
                name
              }
            }
          }
        }
      }
    }
`

export var get_funding_by_id = gql`
  query getFunding($id: ID!){
    project_installment_funding(id: $id){
      ...ProjectInstallmentFundingFields
    }
  }
  ${PROJECT_INSTALLMENT_FUNDING_FRAGMENT}
`

export var get_graph_token = gql`
  query getToken {
    getToken
  }
  `
